import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import { CookieDisclaimerService } from '@signature-it/ngx-generic/services';
import { GenericConfig } from '@signature-it/ngx-generic/config';

@Component({
    selector: 'cookie-disclaimer',
    templateUrl: './cookie-disclaimer.html',
    styleUrls: ['./cookie-disclaimer.scss'],
    standalone: false
})
export class CookieDisclaimerComponent implements OnInit, OnChanges {
    cmsTitle = 'ngx-cookie-disclaimer';
    showCookieDisclaimer: boolean = false;
    @Input() forceEdit: number = 0;
    @Input() privacyPage: boolean = false;


    constructor(protected cookieDisclaimerSvc: CookieDisclaimerService) {}

    ngOnInit() {
        this.cookieDisclaimerSvc.cookieDisclaimer$.subscribe(res => {
            this.showCookieDisclaimer = !res;
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (GenericConfig.showCookieDisclaimer && changes["forceEdit"]) {
            this.showCookieDisclaimer = true;
        }
    }
}
